import { render } from "./GemMechanism11.vue?vue&type=template&id=1fb18cd5&scoped=true"
const script = {}

import "./GemMechanism11.vue?vue&type=style&index=0&id=1fb18cd5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb18cd5"]])

export default __exports__